import { Line } from "react-chartjs-2";

const SalesLineChart = ({ data }) => {
    const labels = data?.dailyData.map((row) => row.Date);
    const salesData = data?.dailyData.map((row) => row.TOTALSALES);

    const chartData = {
        labels: labels,
        datasets: [
            {
                label: "Total Sales",
                data: salesData,
                borderColor: "#4CAF50",
                backgroundColor: "rgba(76, 175, 80, 0.2)",
                pointBorderColor: "#4CAF50",
                pointBackgroundColor: "#fff",
                pointRadius: 5,
                pointHoverRadius: 7,
                fill: true,
                tension: 0,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: "top",
                labels: {
                    font: {
                        size: 14,
                        weight: "bold",
                    },
                    color: "#333",
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Date",
                    font: {
                        size: 14,
                        weight: "bold",
                    },
                },
                ticks: {
                    autoSkip: true,
                    maxRotation: 45,
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Total Sales",
                    font: {
                        size: 14,
                        weight: "bold",
                    },
                },
                beginAtZero: true,
            },
        },
    };

    return (
        <div className="flex justify-center h-[500px] px-44 my-16">
            <Line data={chartData} options={chartOptions} />
        </div>
    );
};

export default SalesLineChart;
